export enum wizardSteps {
  Asset_ChooseContractAndAsset, //Entry new request Step 0
  Asset_RequestType, //Step1
  Asset_Delegate, //Step2
  Asset_CountriesTransit, //Step3
  Asset_AdditionalInsurances, //Step4,
  Asset_RequestSent, //Step5 => WizardCompleted
  Asset_DescribeEvent, //Step6 => _damageDelegacy
  Vignette_Details, //Step7
  Request_Preview,
}

export enum contractModificationsWizardSteps {
  ContractModification_ChooseContractAndModificationType, //Entry new request Step 0
  ContractModification_Why, //Step1
  ContractModification_PaymentSource, //Step2
  ContractModification_AmountPayInAdvance, //Step3,
  ContractModification_RequestPurpose, //Step4
  ContractModification_Preview, //Step5
  ContractModification_RequestSent, //Step6
  ContractModification_PostponePeriod,
}
